import { Controller } from "stimulus"
import { nextFrame, scrollToElement } from "javascripts/helpers"

export default class extends Controller {
  async connect () {
    await nextFrame()
    scrollToElement(this.element)
  }
};
